"use client"

import { useEffect } from "react"
import ProcessIntro from "./ProcessIntro"
import SectionTabs from "./SectionTabs"
import HorizontalSteps from "./HorizontalSteps"
import StepContent from "./StepContent"
import { sectionData } from "../data"

interface AppContentProps {
  activeSection: string
  setActiveSection: (section: string) => void
  activeStep: number
  setActiveStep: (step: number) => void
}

export default function AppContent({ activeSection, setActiveSection, activeStep, setActiveStep }: AppContentProps) {
  // Reset activeStep when section changes
  useEffect(() => {
    setActiveStep(0)
  }, [activeSection, setActiveStep])

  const currentSection = sectionData.find((s) => s.key === activeSection) || sectionData[0]

  // If activeSection doesn't match any section, set it to the first one
  useEffect(() => {
    if (!sectionData.some((s) => s.key === activeSection)) {
      setActiveSection(sectionData[0].key)
    }
  }, [activeSection, setActiveSection])

  // Safety check to ensure activeStep is within bounds
  const safeActiveStep = Math.min(activeStep, (currentSection?.steps?.length || 1) - 1)
  if (safeActiveStep !== activeStep) {
    setActiveStep(safeActiveStep)
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-4">
      <ProcessIntro />

      <SectionTabs sections={sectionData} activeSection={activeSection} setActiveSection={setActiveSection} />

      <HorizontalSteps steps={currentSection?.steps} activeStep={safeActiveStep} setActiveStep={setActiveStep} />

      <StepContent step={currentSection?.steps?.[safeActiveStep]} />
    </div>
  )
}
